import { supabase } from '../lib/supabaseClient';

const TAX_DOCS_API = '/.netlify/functions/get-tax-receipts';

export const taxDocsService = {
  /**
   * Fetch tax receipts for the authenticated user.
   * The Netlify function extracts the email from the JWT —
   * we never send the email as a parameter.
   */
  async fetchReceipts(centerId) {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw new Error('Not authenticated');
    }

    const response = await fetch(`${TAX_DOCS_API}?center_id=${centerId}`, {
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to fetch receipts');
    }

    return response.json();
  }
};

export default taxDocsService;
